import React from "react";

import styles from "./styles.module.scss";

const FetchingConnection = () => (
  <>
    <p className={styles["fetching--conn"]} />
    <div className="clearfix">
      <div className={styles["fetching--recei"]} />
      <div className={styles["fetching--name"]} />
      <div className={styles["fetching--title"]} />
    </div>
  </>
);

export default FetchingConnection;
